import { render, staticRenderFns } from "./ManageIndexHeader.vue?vue&type=template&id=042f2b47"
import script from "./ManageIndexHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./ManageIndexHeader.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports